import * as React from 'react'

const SvgCertificateOrangeIcon = (props) => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4420_105246)">
      <rect x="12" y="0.549805" width="32" height="32" rx="8" fill="#FF692E" />
      <g clipPath="url(#clip0_4420_105246)">
        <path
          d="M24.3333 21.8828H23.3333C22.597 21.8828 22 21.2859 22 20.5495V11.2161C22 10.4798 22.597 9.88281 23.3333 9.88281H32.6667C33.403 9.88281 34 10.4798 34 11.2161V20.5495C34 21.2859 33.403 21.8828 32.6667 21.8828H31.6667M28 21.2161C29.1046 21.2161 30 20.3207 30 19.2161C30 18.1116 29.1046 17.2161 28 17.2161C26.8954 17.2161 26 18.1116 26 19.2161C26 20.3207 26.8954 21.2161 28 21.2161ZM28 21.2161L28.0143 21.216L25.8858 23.3445L24.0002 21.4589L26.0131 19.446M28 21.2161L30.1285 23.3445L32.0142 21.4589L30.0012 19.446M26 12.5495H30M24.6667 14.8828H31.3333"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_4420_105246"
        x="0"
        y="0.549805"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="12"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_4420_105246"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.180392 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4420_105246"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4420_105246"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_4420_105246">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(20 8.5498)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgCertificateOrangeIcon
